import React from 'react';
import styled from 'styled-components';
import { color, typography, variant, system } from 'styled-system';
const textTransform = system({
    textTransform: {
        property: 'textTransform',
    },
});
const textDecoration = system({
    textDecoration: {
        property: 'textDecoration',
    },
});
const whiteSpace = system({
    whiteSpace: {
        property: 'whiteSpace',
    },
});
const Component = styled.p `
  ${color};
  ${typography};
  ${textTransform};
  ${textDecoration};
  ${whiteSpace};
  ${variant({
    prop: 'textSize',
    scale: 'textSizes',
})};

  & > * {
    font-size: inherit;
    line-height: 0 !important;
  }

  ${({ isBold, theme }) => isBold ? `font-weight: ${theme.fontWeights.bold}` : ''};

  ${({ isBrand, theme }) => isBrand ? `font-family: ${theme.fonts.brand}` : ''};

  ${({ isUnderlined }) => (isUnderlined ? 'text-decoration: underline' : '')};
`;
export const Text = ({ htmlAttrs = {}, ...rest }) => (React.createElement(Component, { ...htmlAttrs, ...rest }));
Text.defaultProps = {
    color: 'inherit',
    isBold: false,
    isBrand: false,
    isUnderlined: false,
    textAlign: 'left',
    textSize: 'x2',
};
//# sourceMappingURL=index.js.map